// 2.2业务逻辑设计

// 开户场景：DSCM调用SPI接口，SPI调用CRM的NewConnection接口。DSCM:2686738  前端：2686760 APP:2686765 SPI:2679217  CRM: 2673682
// a）新装接口【drm/ding/custService/newConnection】中【custOrder.orderItemList.resInstList】用来传参实物offer，映射CRM新增的【GoodsDtoList】传参。
// b）新装接口【drm/ding/custService/newConnection】中【custOrder.orderItemList.offerInstList】用来传参个性化资费，映射CRM新增的【VasDtoList】传参。
// c）新装接口【drm/ding/custService/newConnection】中【custOrder.orderItemList.prodInstList】用来传参依赖产品，映射CRM新增的【VasDtoList】传参。
// d）新装接口【drm/ding/custService/newConnection】中【custOrder.orderItemList.prodInstList】下新增【fellowNbrDtoList】和【emailDtoList】，传入SPI接口的【podInst】的【extMap】（key="fellowNbrDtoList 或 emailDtoList"，value=list对象）。

import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import DefaultPricePlan from './DefaultPricePlan';
import IndividualPlan from './IndividualPlan';
import DependentPlan from './DependentPlan';
import GoodsAttr from './GoodsAttr';

import SharedDeviceAttr from '../SharedDeviceAttr';

import { OfferGroupTypeOpt } from './utils';

const OfferAttributes = props => {
  const { offerDetail, modelKey, refInstance, currentDpp, onDppChange, isComboUnit = false, dppOfferList } = props;

  const [offerGroup, setOfferGroup] = useState([]);

  const individualPlanRef = useRef();
  const dependentPlanRef = useRef();
  const sharedDeviceRef = useRef();
  const goodsRef = useRef();

  useImperativeHandle(refInstance, () => ({
    getOfferGroupInfo: async () => {
      const goodsInfo = await goodsRef.current.getGoodsInfo();
      const dependentPlanInfo = await dependentPlanRef.current.getDependentPlanInfo();
      const individualPlanInfo = await individualPlanRef.current.getIndividualPlanInfo();
      if (sharedDeviceRef.current) {
        const sharedDeviceAttr = await sharedDeviceRef.current.getSharedDeviceAttributeInfo();
        return {
          resInstList: goodsInfo,
          offerInstList: individualPlanInfo,
          prodInstList: dependentPlanInfo,
          sharedGoodsAttrDtoList: sharedDeviceAttr,
        };
      }

      return {
        resInstList: goodsInfo,
        offerInstList: individualPlanInfo,
        prodInstList: dependentPlanInfo,
      };
    },
  }));

  useEffect(() => {
    if (offerDetail) {
      const { offerGroupDtoList = [] } = offerDetail || {};
      const offerGroupTypeObj = {
        [OfferGroupTypeOpt.DEPENDENT_PLAN]: [],
        [OfferGroupTypeOpt.INDIVIDUAL_PLAN]: [],
        [OfferGroupTypeOpt.GOODS]: [],
      };
      Object.keys(offerGroupTypeObj).forEach(key => {
        const offerGroupForm =
          offerGroupDtoList.filter(it => `${key}` === `${it.offerGroupType}` && `${it.necessary}` === '1') || [];
        offerGroupTypeObj[key] = offerGroupForm.map(it => ({
          ...it,
          lowLimit: it.lowLimit ? it.lowLimit : 1, // 这段逻辑，我是真的死活不想加的，就是在帮crm擦屁股
        }));
      });
      setOfferGroup(offerGroupTypeObj);
    }
  }, [offerDetail]);

  const renderSharedDevice = () => {
    // combo状态增加sharedGoodsAttrDtoList采集
    // 承载套餐属性采集
    const servType = `${get(offerDetail, 'indepProdSpecDto.servType') || ''}`;
    if (isComboUnit && servType === '79' && modelKey === 'newConnection') {
      return (
        <div style={{ marginBottom: '10px' }}>
          <SharedDeviceAttr ref={sharedDeviceRef} modelKey={modelKey} />
        </div>
      );
    }
    return '';
  };

  return (
    <div>
      {/* combo子套餐需要在这里选择默认资费计划 */
      isComboUnit && <DefaultPricePlan currentDpp={currentDpp} onDppChange={onDppChange} dppOfferList={dppOfferList} />}
      {/* 个性化资费 */}
      <IndividualPlan
        ref={individualPlanRef}
        offerGroupArr={offerGroup[OfferGroupTypeOpt.INDIVIDUAL_PLAN] || []}
        modelKey={modelKey}
      />
      {/* 依赖产品 */}
      <DependentPlan
        ref={dependentPlanRef}
        offerGroupArr={offerGroup[OfferGroupTypeOpt.DEPENDENT_PLAN] || []}
        offerDetail={offerDetail}
        modelKey={modelKey}
      />
      {/* 实物offer */}
      <GoodsAttr ref={goodsRef} offerGroupArr={offerGroup[OfferGroupTypeOpt.GOODS] || []} modelKey={modelKey} />
      {renderSharedDevice()}
    </div>
  );
};

const Component = connect()(OfferAttributes);
export default React.forwardRef((props, ref) => <Component {...props} refInstance={ref} />);
